// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"28a12654","977":"b2ace1f7"}[chunkId] + ".chunk.js";
};